import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'

import type {PipelineDraftState} from './EditPipelinePage.slices.types'
import {getPipelineDraftEntry} from './EditPipelinePage.slices.utils'

export const changeTrigger: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    index: number
    parameters?: Record<string, string>
    triggerBranches?: boolean
    triggerPullRequests?: boolean
    branch: string
  }>
> = (state, action) => {
  const {id, index, parameters, triggerBranches, triggerPullRequests, branch} = action.payload
  const {triggers} = getPipelineDraftEntry(state, id, branch)?.draft ?? {}

  if (triggers) {
    const trigger = triggers[index]

    triggers[index] = {
      ...trigger,
      triggerBranches,
      triggerPullRequests,
      parameters,
    }
  }
}

export const toggleDisabledTrigger: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    index: number
    value: boolean
    branch: string
  }>
> = (state, action) => {
  const {id, index, value, branch} = action.payload
  const {triggers} = getPipelineDraftEntry(state, id, branch)?.draft ?? {}

  if (triggers) {
    triggers[index].disabled = value
  }
}

export const addTrigger: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    type: string
    parameters?: Record<string, string>
    disabled?: boolean
    triggerBranches?: boolean
    branch: string
  }>
> = (state, action) => {
  const {id, branch, ...trigger} = action.payload

  const {draft} = getPipelineDraftEntry(state, id, branch) ?? {}
  if (draft != null) {
    draft.triggers ??= []

    draft.triggers.push(trigger)
  }
}

export const deleteTrigger: CaseReducer<
  PipelineDraftState,
  PayloadAction<{id: string; index: number; branch: string}>
> = (state, action) => {
  const {id, index, branch} = action.payload

  const {draft} = getPipelineDraftEntry(state, id, branch) ?? {}
  if (draft != null) {
    draft.triggers ??= []

    draft.triggers.splice(index, 1)
  }
}
